import Vue from 'vue';
import { performFetch } from './helpers'
import store from '../src/store/store.js'

export const NORMAL_FIELDS = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15];


export const isFieldDisabled = (field, disabledFields = [], action = 'view') => {
  if (!field.can_edit || field.is_disabled || disabledFields.includes(field.hash) || action === 'view') {
    return true
  } else {
    return false
  }
};

export const formatFieldValueToComponent = (field) => {
  switch (field.type_id) {
    case Vue.prototype.$FIELD_TYPES.NUMBER:
    case Vue.prototype.$FIELD_TYPES.DECIMAL:
    case Vue.prototype.$FIELD_TYPES.CURRENCY:
      if (field.payload === null) {
        return 0;
      }

      if (typeof field.payload === 'string') {
        return parseFloat(field.payload);
      }

      return field.payload;

    case Vue.prototype.$FIELD_TYPES.MULTIPLE_DATE:
      if (Array.isArray(field.payload)) {
        return field.payload.join(", ")
      }

    case Vue.prototype.$FIELD_TYPES.PICKLIST:
    case Vue.prototype.$FIELD_TYPES.RELATED_TO_A_MODULE:

      if (Array.isArray(field.options) && field.options.length > 0 && field.payload !== null) {
        return field.options.find(x => x.value === field.payload);
      } else if (field.options !== null & typeof field.options === 'object' && field.payload !== null) {
        for (const options of Object.values(field.options)) {
          const findItem = options.find(x => x.value === field.payload);
          if (findItem !== undefined) {
            return findItem;
          }
        }
        return null;
      }

      case Vue.prototype.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE:
      if (Array.isArray(field.options) && field.payload !== null && field.options.length > 0) {
        return field.options.filter(x => field.payload.includes(x.value));
      } else if ((!Array.isArray(field.options) && typeof field.options === 'object') && field.payload !== null && field.payload.length > 0) {
        const allOptions = Object.values(field.options).flat();
        return allOptions.filter(x => field.payload.includes(x.value));
      } else {
        return null
      }



    // case Vue.prototype.$FIELD_TYPES.DATE:
    //   return new Date(fieldValue);
    // case Vue.prototype.$FIELD_TYPES.CHECKBOX:
    //   return fieldValue;
    // case Vue.prototype.$FIELD_TYPES.SELECT:
    //   return fieldValue;
    // case Vue.prototype.$FIELD_TYPES.MULTI_SELECT:
    //   return fieldValue;
    // case Vue.prototype.$FIELD_TYPES.RADIO:
    //   return fieldValue;
    // case Vue.prototype.$FIELD_TYPES.FILE:
    //   return fieldValue;
    default:
      return field.payload;
  }
}


export const formatFieldValues = (fieldValues, fieldTypes) => {
  // const formattedFieldValues = {};
  // fieldValues.forEach((field) => {
  //   formattedFieldValues[field.field_id] = field.value
  // });
  // return formattedFieldValues

  const newData = {};

  for (const [key, value] of Object.entries(fieldValues)) {

    switch (fieldTypes[key]) {
      case Vue.prototype.$FIELD_TYPES.RELATED_TO_A_MODULE:
      case Vue.prototype.$FIELD_TYPES.PICKLIST:
        if (value !== null && Object.keys(value).length > 0) {
          newData[key] = value.value;
        } else {
          newData[key] = null;
        }
        break;
      case Vue.prototype.$FIELD_TYPES.INTEGER:
        if(value !== null) {
          newData[key] = parseInt(value);
        } else {
          newData[key] = null;
        }
        break;
      case Vue.prototype.$FIELD_TYPES.RELATED_TO_A_MODULE_MULTIPLE:
        if (value !== null && Array.isArray(value) && value.length > 0) {
          newData[key] = value.map(item => item.value);
        } else {
          newData[key] = [];
        }
        break;
      // case Vue.prototype.$FIELD_TYPES.NUMBER:
      //   newData[key] = Number(value);
      //   break;
      // case Vue.prototype.$FIELD_TYPES.CHECKBOX:
      //   newData[key] = value;
      //   break;
      // case Vue.prototype.$FIELD_TYPES.SELECT:
      //   newData[key] = value;
      //   break;
      // case Vue.prototype.$FIELD_TYPES.MULTI_SELECT:
      //   newData[key] = value;
      //   break;
      // case Vue.prototype.$FIELD_TYPES.RADIO:
      //   newData[key] = value;
      //   break;
      // case Vue.prototype.$FIELD_TYPES.FILE:
      //   newData[key] = value;
      //   break;

      case Vue.prototype.$FIELD_TYPES.MULTIPLE_DATE:

        if (typeof value === 'string') {
          newData[key] = value.split(", ")
        } else {
          newData[key] = null;
        }

        break
      default:
        newData[key] = value;
    }
  }

  return newData;
}


export const submitFormData = async (actionType, data, moduleToken, rowHash = null) => {

  let command = null;

  if (actionType === 'add') {
    command = 'add_module_row';
  } else {
    command = 'update_module_row';
  }

  return await performFetch(store.state.auth.api_url, {
    command: command,
    parameters: {
      application_token: store.state.auth.app_token,
      session_token: store.state.auth.token,
      module_token: moduleToken,
      row_hash: rowHash,
      data: data
    }
  })
    .then(async response => {
      if (response.status === 200) {
        const jsonResponse = await response.json()
        return jsonResponse;
      } else {
        throw new Error(response);
      }
    })
    .catch(error => {
      throw new Error(error);
    })

}


export const deleteModuleRow = async (moduleToken, rowHash) => {

  return await performFetch(store.state.auth.api_url, {
    command: 'delete_module_row',
    parameters: {
      application_token: store.state.auth.app_token,
      session_token: store.state.auth.token,
      module_token: moduleToken,
      row_hash: rowHash
    }
  })
    .then(async response => {
      if (response.status === 200) {
        const jsonResponse = await response.json()
        return jsonResponse;
      } else {
        throw new Error(JSON.stringify(response));
      }
    })
    .catch(error => {
      throw new Error(error);
    })

}
